

const scrollTreshhold = 0;
const stickyNav = document.querySelector('.main-nav');
const mainHeader = document.querySelector('.main-header');
const buttonOutline = document.querySelector('.button--outline');

export default function setupStickyNav () {
    window.addEventListener('DOMContentLoaded', setMainNavScrolled);
    window.addEventListener('scroll', setMainNavScrolled);
}



/**
 * Adds the 'main-nav--scrolled' class to the main nav if the user has scrolled down more than the scroll treshhold
 */
function setMainNavScrolled() {
    if ( !stickyNav ) return;

    if (window.scrollY > scrollTreshhold) {
        stickyNav.classList.add('main-nav--scrolled');

        if ( buttonOutline ) {
            buttonOutline.classList.remove('button--glass');
            buttonOutline.classList.add('button--outline');
        }
    } else {
        stickyNav.classList.remove('main-nav--scrolled');

        if ( buttonOutline ) {
            buttonOutline.classList.remove('button--outline');
            buttonOutline.classList.add('button--glass');
        }
    }

    if ( !mainHeader ) {
        buttonOutline.classList.remove('button--glass');
        buttonOutline.classList.add('button--outline');
    }
}
